import { lazy, Suspense } from "react";
import Navbar from "../components/neptune/Navbar";
import Hero from "../components/neptune/Hero";

// Defer the below-the-fold sections — they ship in a separate JS chunk and only load
// once the user starts to scroll. Big perceived speed boost on mobile / 3G.
const TrustStrip = lazy(() => import("../components/neptune/TrustStrip"));
const ThreePillars = lazy(() => import("../components/neptune/ThreePillars"));
const WhyNeptune = lazy(() => import("../components/neptune/WhyNeptune"));
const FinalCTA = lazy(() => import("../components/neptune/FinalCTA"));
const Footer = lazy(() => import("../components/neptune/Footer"));

const Skeleton = ({ h = "h-[400px]" }) => (
  <div className={`${h} bg-transparent`} aria-hidden="true" />
);

export default function Landing() {
  return (
    <main
      data-testid="neptune-landing"
      className="relative min-h-screen bg-[#0a0a0a] text-white font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <Suspense fallback={<Skeleton h="h-[120px]" />}>
        <TrustStrip />
      </Suspense>
      <Suspense fallback={<Skeleton h="h-[600px]" />}>
        <ThreePillars />
      </Suspense>
      <Suspense fallback={<Skeleton h="h-[600px]" />}>
        <WhyNeptune />
      </Suspense>
      <Suspense fallback={<Skeleton h="h-[400px]" />}>
        <FinalCTA />
      </Suspense>
      <Suspense fallback={<Skeleton h="h-[200px]" />}>
        <Footer />
      </Suspense>
    </main>
  );
}
